export const refreshCurrPage = (url) => {
  const route = useRoute();
  const router = useRouter();
  if (route.path === url) {
    router.go(0);
  }
};
